import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingOverlay = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  backdropFilter: 'blur(2px)',
}));

const LoadingContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  boxShadow: theme.shadows[24],
}));

const Loading = () => {
  return (
    <Fade in timeout={300}>
      <LoadingOverlay
        role="alert"
        aria-label="Carregando, aguarde..."
        aria-busy
      >
        <LoadingContent>
          <CircularProgress 
            size={60} 
            thickness={4}
            sx={{
              color: (theme) => theme.palette.primary.main,
            }}
          />
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              fontWeight: 500,
              animation: 'pulse 2s ease-in-out infinite',
              '@keyframes pulse': {
                '0%, 100%': {
                  opacity: 0.7,
                },
                '50%': {
                  opacity: 1,
                },
              },
            }}
          >
            Carregando...
          </Typography>
        </LoadingContent>
      </LoadingOverlay>
    </Fade>
  );
};

export default Loading;
